import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.div`
    flex-grow: 1;
    margin-right: 14px;
    margin-bottom: 36px;

    .app-info { display: flex; justify-content: flex-start; }
    .app-info .app-icon-container { margin-right: 25px; min-width: 120px; height: 120px; }
    .app-info .app-icon-container img { width: 100%; border-radius: 20px; }

    .app-description { display: flex; flex-direction: column; justify-content: space-between; }
    .app-description .app-name {
        font-family: 'Montserrat';
        font-size: 22px;
        font-weight: 300;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.09em;
        text-transform: uppercase;
    }
    
    .app-details {
        line-height: 25px;
        font-family: 'Roboto';
        font-size: 15px;
        color: rgba(147, 147, 147, 1);
        text-align: justify;
        letter-spacing: 0.04em;
    }

    .app-info + .app-details { margin-top: 20px; }

    @media screen and (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 30px;

        .app-info .app-icon-container { margin-right: 7px; min-width: 68px; width: 68px; height: 68px; }
        .app-description { justify-content: center; }
        .app-description .app-name { top: -7px; }
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/AppHeader/Wrapper.js